<t
<template>
    <v-flex xl12>
        <v-card flat>
            <v-card-text>
                <v-snackbar top v-model="success" color="success">
                    <span> <v-icon>check_circle</v-icon> {{messages}} </span>
                </v-snackbar>
                <v-snackbar top v-model="error" color="error">
                    <span> <v-icon>info</v-icon> {{messages}} </span>
                </v-snackbar>
                <h3>Novo usuário</h3>
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-text-field
                            v-model="fields.full_name"
                            :rules="nameRules"
                            label="Name"
                            required
                    ></v-text-field>

                    <v-text-field
                            v-model="fields.email"
                            :rules="emailRules"
                            label="E-mail"
                            required
                    ></v-text-field>
                    <v-btn flat class="primary" @click="submit">Salvar</v-btn>
                    <v-btn flat class="secondary" @click="clear">Cancelar</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-flex>
</template>
<script>
    export default {
        name: 'users-add',
        data: () => ({
            fields: {
                full_name: '',
                email: ''
            },
            valid: true,
            error: false,
            success: false,
            messages: '',
            nameRules: [
                v => !!v || 'Campo obrigatório',
            ],
            emailRules: [
                v => !!v || 'O E-mail é obrigatório',
                v => /.+@.+/.test(v) || 'E-mail inválido'
            ],
        }),
        methods: {
            submit() {
                var self = this
                this.error = false
                this.messages = ''
                if (this.$refs.form.validate()) {
                    self.$store.commit('setLoading', true)
                    this.axios.post('/add-users.json', self.fields, {
                        headers: {
                            'Authorization': this.$store.state.token
                        }
                    }).then(function (response) {
                        self.loading = false
                        if (response.data.success === true) {
                            self.$store.commit('setLoading', false)
                            self.messages = response.data.messages
                            self.success = true
                            setTimeout(function () {
                                self.$router.push('/users')
                            }, 2000)
                        } else {
                            self.error = true
                            self.loading = false
                            self.messages = response.data.messages
                        }
                    })
                }
            },
            clear() {
                this.fields.full_name = ''
                this.fields.email = ''
                this.$router.push('/users')
            }
        },
        mounted: function () {
            this.$nextTick(function () {

            })
        }
    }
</script>
